import componentStyles from "../css/App.module.css";

export default function FooterComponent() {
    return (
        <div className={componentStyles.center}>
            <p className={componentStyles.copyright}>Yujia (Bobo) Wang &copy; 2023 All Rights Reserved.</p>
        </div>
    );
}